import styled from 'styled-components';
import {palette} from '@/styles';
import LogoPlaceholder from './logo-placeholder.png';

interface IProps {
  url?: string;
}

export const BrandLogoBig = ({url}: IProps) => {
  return (
    <Root
      style={{
        backgroundImage: `url(${url || LogoPlaceholder})`,
      }}
    />
  );
};

const Root = styled.div`
  border-radius: 20px;
  border: 1px solid ${palette.gray150};
  width: 64px;
  height: 64px;
  flex-shrink: 0;
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;
`;
